<dx-popup
    class="popup"
    [width]="isPhone ? isPhoneLandscape ? '90vw' : '100%' : 680"
    [height]="'80vh'"
    [showTitle]="true"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [showCloseButton]="false"
    [maxHeight]="'80vh'"
    [resizeEnabled]="false"
    [(visible)]="popupVisible"
>
    <dxi-toolbar-item location="before">
        <h3 fxShow fxHide.xs style="margin: 5px 0">
            Search Physician
        </h3>
        <h4 fxShow fxHide.gt-xs style="margin: 5px 0">
            Search Physician
        </h4>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="before">
        <dx-load-indicator
            height="20"
            width="20"
            [(visible)]="isLoading"
            style="margin-left: 8px;margin-top: 4px"
        ></dx-load-indicator>
    </dxi-toolbar-item>

    <dxi-toolbar-item location="after">
        <dx-button text="Close" (click)="close()"></dx-button>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after">
        <dx-button text="Search" (click)="submitSearch()" [disabled]="physicianDialogForm.invalid"></dx-button>
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'" [ngStyle.xs]="{height: '100%'}">
        <form [formGroup]="physicianDialogForm" [ngStyle.xs]="{height: '100%'}" style="height: inherit">
            <div fxLayout="column" fxLayout.xs="column" fxLayout.sm="row" style="height: inherit">
                <div id="form"
                     [ngStyle.sm]="{width: '39%', 'padding-right': '3px', height: '100% !important;'}"
                     style="width: 100%; height: auto;" class="filters" fxLayout="row"
                     fxLayoutAlign="center">
                    <div class="ocl-dialog-content" fxLayout="column" fxLayoutAlign="start space-between">
                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start"
                             fxLayoutAlign="start start"
                             [ngStyle.lt-md]="{width: '100%'}">
                            <div class="dx-fieldset" [ngClass.lt-md]="{marginBottom: '0 !important'}">
                                <div class="dx-field">
                                    <div class="dx-field-label">
                                        Last Name
                                    </div>
                                    <div class="dx-field-value">
                                        <dx-text-box #lastNameTextBox class="uppercase"
                                                     formControlName="lastName">
                                        </dx-text-box>
                                    </div>
                                </div>
                                <div class="dx-field">
                                    <div class="dx-field-label">
                                        First Name
                                    </div>
                                    <div class="dx-field-value">
                                        <dx-text-box class="uppercase" formControlName="firstName">
                                        </dx-text-box>
                                    </div>
                                </div>
                            </div>
                            <div class="dx-fieldset">
                                <div class="dx-field">
                                    <div class="dx-field-label">
                                        NPI
                                    </div>
                                    <div class="dx-field-value">
                                        <dx-text-box class="uppercase" formControlName="npi">
                                        </dx-text-box>
                                    </div>
                                </div>
                                <div *ngIf="patientClientId !== -1" style="width: 250px !important; margin-top: 35px;"
                                    [ngStyle.xs]="{'margin-top': '8px;', 'margin-bottom': '8px'}">
                                    <dx-check-box
                                        [value]="false"
                                        text="Physicians associated to Client"
                                        formControlName="sameAsClient"
                                    ></dx-check-box>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="height: calc(80vh - 120px - 59px - 32px);"
                     [ngStyle.sm]="{width: '60%', height: '100%'}"
                     [ngStyle.xs]="{height: patientClientId === -1 ? 'calc(80vh - 171px - 59px - 32px)' : 'calc(80vh - 192px - 59px - 32px)'}" >
                    <ng-container
                        *ngTemplateOutlet="physiciansGrid; context: { dataSource: searchedPhysicians.value }"
                    ></ng-container>
                </div>
            </div>
        </form>
    </div>
</dx-popup>

<ng-template #physiciansGrid let-dataSource="dataSource">
    <dx-data-grid [dataSource]="dataSource"
                  [showRowLines]="true"
                  (onRowClick)="rowClick($event)"
                  [height]="'100%'"
                  [showBorders]="true"
                  [hoverStateEnabled]="true"
                  [highlightChanges]="true"
                  [columnAutoWidth]="true"
                  [allowColumnResizing]="true"
                  [columnHidingEnabled]="isPhone || isPhoneLandscape || isTablet"
                  style="min-width: 250px !important;">
        <dxo-remote-operations [filtering]="true" [sorting]="true" [paging]="true"></dxo-remote-operations>
        <dxi-column caption="NPI" cellTemplate="selectTemplate"
                    [hidingPriority]="isPhone || isPhoneLandscape || isTablet ? 2 : -1"></dxi-column>
        <dxi-column caption="Last Name" dataField="lastName"></dxi-column>
        <dxi-column caption="First Name" dataField="firstName"></dxi-column>

        <div *dxTemplate="let d of 'selectTemplate'">
            <a (click)="resultSelected(d.data)" class="tooltip" style="cursor: pointer" title="Click to select">{{
                d.data.npi
                }}</a>
        </div>
    </dx-data-grid>
</ng-template>
